module.exports = __webpack_public_path__ + "img/Pic_Text_PDA.1b2afdbd.png";